export default {
    getDefaultSortColumnOptions(settings) {
        let defaultSort = settings.columns.filter(x => x.sort && x.sort['default'] == true);
        return (defaultSort.length > 0) ? (defaultSort[0]['displayFieldText'] ? defaultSort[0]['displayFieldText'] :   defaultSort[0]['columnName']) : '';
    },
    sortMultipleCols(filteredData,sortField,sortBy,settings){
        filteredData = this.sortFields(filteredData, sortBy, sortField);
        let newData = [];
        let newDataTemp = [];
        let primaryCols = [];
        primaryCols = this.getPrimaryColumnNames(settings);
        if(primaryCols.length > 0){
                    let uniqueData = this.getColData(filteredData, sortField);
          uniqueData.forEach(ele => {
                    let tempData = filteredData.filter(x => x[sortField] == ele);
            for(let i = 0; i<primaryCols.length; i++){
                    let index = settings.columns.findIndex(cl=>cl.columnName == primaryCols[i].colName);
              if(sortField != primaryCols[i].colName && index!=-1){
                    settings.columns[index].sort.sortBy = primaryCols[i].defaultSort;
              }
              if(i == 0){
                tempData =  this.sortFields(tempData, primaryCols[i].defaultSort, primaryCols[i].sortColName);
                    tempData.forEach(nele => {
                        newData.push(nele);
                    });
              } else{
                    let uniquePrimaryData = [];              
                    uniquePrimaryData = this.getColData(tempData, primaryCols[i-1].colName);
                    uniquePrimaryData.forEach(uele => {
                        let tempDataPrimary = tempData.filter(x => x[primaryCols[i-1].colName] == uele);
                        tempDataPrimary =  this.sortFields(tempDataPrimary, primaryCols[i].defaultSort, primaryCols[i].sortColName);
                        tempDataPrimary.forEach(nele => {
                            newData.push(nele);
                            newDataTemp.push(nele);
                        });
                    });
                }             
            }    
          })
        }else{
            newDataTemp = filteredData;
        }
        if(primaryCols.length == 1)
            newDataTemp = newData;
        return newDataTemp;
    },
    getColData(data, colName){
        let colData = [];
        data.forEach(ele => {
          colData.push(ele[colName]);
        });
        colData = new Set(colData);
        return colData;
    }, 
    getPrimaryColumnNames(settings,sortField){
           let defaultSort = settings.columns.filter(x=>x.sort &&  x.sort['primaryColumn'] == true);        
           let primaryColumnNames =[];
           let sortOrderVals = [];
           defaultSort.map(ele => {
           if(ele.columnName != sortField){
           let defaultSort = typeof ele.sort.defaultSort == 'undefined' ? 'asc' : ele.sort.defaultSort;
           let sortOrder = typeof ele.sort.sortOrder == 'undefined' ? primaryColumnNames.length + 1 : ele.sort.sortOrder;
           if(typeof ele.sort.sortOrder == 'undefined' && primaryColumnNames.length == 0){
             sortOrderVals.push(1);
             }
           else if(typeof ele.sort.sortOrder == 'undefined'){
           let maxVal = sortOrderVals.reduce((a,b) => Number(a.bid) > Number(b.bid) ? a : b);
             sortOrderVals.push(maxVal + 1);
           }
           primaryColumnNames.push({colName: ele.columnName, sortColName : (ele.displayFieldText && ele.displayFieldText!='')? ele.displayFieldText : ele.columnName, sortBy: ele.sort.sortBy, defaultSort:defaultSort, order: sortOrder});              
             }
           });       
           primaryColumnNames = this.sortFields(primaryColumnNames, 'asc', 'order');
           return  primaryColumnNames;
    },
    sortFields(filteredData, sortBy, field) {
        var sortByDirection = sortBy == 'asc' ? 1 : -1;
        filteredData = filteredData.slice().sort(function (a, b) {
        if(isNaN(a[field])){
            a = a[field] ? a[field].toLowerCase().trim() : ''
            b = b[field] ? b[field].toLowerCase().trim() : ''
          }
          else {
            a = a[field] ? parseInt(a[field]) : 0
            b = b[field] ? parseInt(b[field]) : 0
          }
          if(sortByDirection == 1) {
            return (!a)-(!b) || +(a>b)||-(a<b);  //asc
          }
          else {
            return (!a)-(!b) || -(a>b)||+(a<b); //desc
          }
        });   
        return filteredData;
    },
};

